<template>
    <div>
        <h3 class="mb-3 mt-2">Issue Type DropDown</h3>
        <vx-card noShadow noRound>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <InputSelect
                        :model.sync="issue_type_category"
                        label="Issue Type"
                        placeholder="Choose ..."
                        container_class="w-auto input-custom-dropdown"
                        :options="issue_type_category_options"
                        :multiple="false"
                    />
                </vs-col>
                <template v-if="issue_type_category">
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                        <SelectForeign
                            :model.sync="issue_type.category"
                            label="Category"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['name']"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.data_categories}?issue_type_category=${issue_type_category}`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="true"
                            :disabled="!issue_type_category"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.category">
                            {{ api_errors.category.join(', ') }}
                        </small>
                    </vs-col>
                </template>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <vs-input
                        v-model="issue_type.name"
                        label="Name"
                        class="w-full"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.name">
                        {{ api_errors.name.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block">Is Active</label>
                    <div class="flex mt-3 align-center">
                        <vs-radio v-model="issue_type.active" vs-name="active" :vs-value="true">Yes</vs-radio>
                        <vs-radio v-model="issue_type.active" vs-name="active" :vs-value="false" class="mx-3">No</vs-radio>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.active">
                        {{ api_errors.active.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
            <vs-row class="mt-base">
                <vs-col class="text-center">
                    <vs-button @click="save" :disabled="submit_disabled">
                        Save
                    </vs-button>
                </vs-col>
            </vs-row>
        </vx-card>
    </div>
</template>

<script>
import { Request } from '../../../utils/requests'

export default {
    data() {
        return {
            issue_type_id: this.$route.params.issue_type_id,

            issue_type: {
                name: null,
                active: true,
                category: null
            },

            issue_type_category: null,

            issue_type_category_options: [
                {value: 'incident', label: "Incident"},
                {value: 'highway', label: "Corrective Maintenance"},
                {value: 'hazard', label: "Hazard"},
                {value: 'asset_register', label: "Asset Register"},
                {value: 'routine_maintenance', label: "Routine Maintenance"},
                {value: 'major_maintenance', label: "Major Maintenance"},
                {value: 'electrical_maintenance', label: "Electrical Maintenance"},
            ],

            submit_disabled: false,
            api_errors: {}
        }
    },
    watch: {
        "$route.params.issue_type_id"(newV, oldV) {
            if (newV == oldV) return;
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.issue_type_id = this.$route.params.issue_type_id

            if (this.issue_type_id) this.load_data()
            else this.issue_type = {
                name: null,
                active: true,
                category: null
            }
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.issue_type_get + this.issue_type_id + "/"
            
            this.$vs.loading()
            
            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.issue_type = res
                    this.issue_type_category = res.category.issue_type_category
                },
                err => {
                    this.$vs.loading.close()
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let request_method = 'POST', url = this.$store.state.apiendpoints.issue_type_get
            if (this.issue_type_id) {
                request_method = 'PUT'
                url += this.issue_type_id + '/'
            }

            let payload = this.issue_type

            this.submit_disabled = true

            Request(this, request_method, url, null, payload).then(
                res => {
                    this.submit_disabled = false
                    this.issue_type = res
                    this.issue_type_category = res.category.issue_type_category
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved Successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    this.$router.push({name: 'issue-type-list'})
                },
                err => {
                    this.submit_disabled = false
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })

                    }
                }
            )
        }
    }
}
</script>